import PlusIcon from '@/assets/common/plus.svg?react';
import styles from './ArticleCollectionBadges.module.scss';

interface ArticleCollectionBadgesProps {
  articleId: string;
  onAddToCollection?: () => void;
}

export function ArticleCollectionBadges({
  onAddToCollection,
}: ArticleCollectionBadgesProps) {
  // Note: Collection membership query was removed in the collections revamp.
  // This component now only shows the "Add to Collection" button.

  return (
    <div className={styles.articleCollectionBadges}>
      {onAddToCollection && (
        <button
          className={styles.articleCollectionBadges__addButton}
          onClick={onAddToCollection}
        >
          <PlusIcon />
          Add to Collection
        </button>
      )}
    </div>
  );
}
